/*
  useReadOnly.js
*/

// Hooks.
import useBotech from './useBotech';

/**
 * Hook to return whether the app is in read-only mode or not.
 */
export default function useReadOnly() {

  const botech = useBotech();

  return botech.readOnly === true;

}
